<!-- 问答管理 企业端 -->
<template>
  <div>
    <el-card class="box-card set-card" style="position: relative">
      <div class="box-top">
        <el-col :span="10">
          <el-button type="primary theme-btn" @click="addClickNew" class="btn">添加问题</el-button>
        </el-col>
      </div>
      <div class="text item">
        <el-table style="width: 100%" :data="articleData" class="table-content">
          <el-table-column align="center" show-overflow-tooltip width="100" label="序号" :fit="true"
                           type="index"></el-table-column>
          <el-table-column align="center" show-overflow-tooltip width="354" label="问题"
                           prop="questions"></el-table-column>
          <el-table-column align="center" show-overflow-tooltip label='回答' width="355" prop="answers"></el-table-column>
          <el-table-column label="操作" align="center" width="230">
            <template slot-scope="scope">
              <el-button @click="seeyou(scope.row)" size="small" class="table-compile">查看</el-button>
              <el-button type="primary" @click="modify(scope.row)" size="small" class="table-compile">编辑</el-button>
              <el-button @click="deleteClick(scope.row)" size="small" type="danger" class="table-compile">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagelist" style="text-align: center">
        <el-row type="flex" justify="center">
          <el-col :span="24" class="nomore" style="margin-top:24px;">
            <!-- <span v-if="isShow">没有更多了</span> -->
            <el-pagination
                v-if="pagination"
                class="page"
                background
                :current-page="currentPage1"
                @current-change="current_page"
                layout="total, prev, pager, next, jumper"
                :total="dataNumber">
            </el-pagination>
          </el-col>
        </el-row>
      </div>
    </el-card>
  </div>
</template>
<script>
import login from "@/views/login/login";

export default {
  data() {
    return {
      page: 1,
      size: "10",
      dataNumber: 0, // 有多少条数据
      currentPage1: 1,
      pagination: true,
      articleData: [],
    };
  },
  created() {
  },
  mounted() {
    this.getAricleFn(this.page, this.size);
  },
  methods: {
    // 添加问题
    addClickNew() {
      this.$router.push({
        path: '/answersPeopleNewadded2',
        query: {
          title: '新增问题',
          status: '1',
        }
      });
    },
    // 查看
    seeyou(val) {
      this.$router.push({
        path: "/answersPeopleNewadded2",
        query: {
          id: val.id,
          title: '查看问题',
          status: '1',
        },
      })
    },
    // 删除
    deleteClick(val) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.axiosPost(`/questionsAnswers/deleteById/${val.id}`, {}).then((res) => {
          if (res.code == 200) {
            this.$message.success(res.message)
            this.getAricleFn(this.page, this.size);
          } else {
            this.$message.success(res.message)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //获取列表
    getAricleFn() {
      this.axiosGet(`/questionsAnswers/page/${this.page}/${this.size}`, {
        params: {
          type: 2,
        }
      }).then((res) => {
        if (res.code == 200) {
          this.articleData = res.data.list;
          this.dataNumber = res.data.total;
        }
      });
    },
    // 编辑
    modify(val) {
      console.log('val :>> ', val);
      this.$router.push({
        path: "/answersPeopleNewadded2",
        query: {
          id: val.id,
          title: '修改问题',
          status: '1',
        },
      })
    },
    //分页
    current_page(currentPage) {
      this.page = currentPage;
      this.getAricleFn(this.page, this.size);
    },
  },
  filters: {
    checkVal(str) {
      let reg1 =
          /<img.*?>|<p>|<\/p>|<u>|<\/u>|<strong>|<\/strong>|<em>|<\/em>|<h1>|<\/h1>|<h2>|<\/h2>|<sub>|<\/sub>|<span.*?<\/span>|<sup>|<\/sup>|<h1.*?>|<sup.*?>/gi;
      str = str.replace(reg1, "").substring(0, 200);
      return str;
    },
  },

  updated() {
  },
}
;
</script>
<style lang="less" scoped>


.newsList-box {
  width: 100%;

  .newsItemBox {
    transition: .2s;
    padding-left: 30px;
    display: flex;
    justify-content: space-between;

    .title-Top {
      line-height: 60px;
      color: black;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      width: 300px;

    }

    .BelongingContent {
      line-height: 60px;
      color: black;
    }

    .updateTime {
      line-height: 60px;
    }

    .content-bottom {
      line-height: 60px;
      margin-right: 30px;
    }
  }

  .newsItemBox:hover {
    box-shadow: 0px 3px 19px 5px rgba(42, 112, 255, 0.13);
  }
}

// 分页
.box-card {
  .box-top {
    padding: 20px 32px 0 30px;
    display: flex;
    align-items: center;
    margin-bottom: 8px;

    .sendNewsBtn {
      width: 136px;
      height: 48px;
      border: 2px solid #1A80FC;
      border-radius: 8px;
      background: #fff;
      color: #1A80FC;
    }
  }

}

.nomore {
  line-height: 50px;
  text-align: center;
  margin-top: 24px
  // margin-top:10px;
}

.small-title {
  position: absolute;
  top: 0;
  right: 0;
  width: 45%;
  height: 25px;
  background: rgba(0, 0, 0, .5);
  color: #ffffff;
  font-size: 9px;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 25px;
  text-align: center;
  border-bottom-left-radius: 4px;
}
</style>
